<div class="main-container" style="height: 100vh;">
    <div class="page-content">
        <div fxLayout="row wrap">
            <div fxFlex.gt-lg="30" fxFlex.gt-md="30" fxFlex.gt-xs="100" fxFlex="100"></div>
            <div fxFlex.gt-lg="40" fxFlex.gt-md="40" fxFlex.gt-xs="100" fxFlex="100" style="padding-top: 20px;">
                <mat-card>
                    <mat-card-title>
                        <div class="logo_container">
                            <img class="logo" src="https://pusmenjar.kemdikbud.go.id/keuangan/assets/img/logo.png" />

                            <span class="small-center-text"> Sistem Informasi Kepegawaian </span>
                            <span class="small-center-text"> Pusat Asesmen Pendidikan </span>
                        </div>
                    </mat-card-title>
                    <mat-card-content>
                        <form class="form-container" *ngIf="!isLoggedIn" name="form"
                            (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
                            <mat-form-field appearance="outline">
                                <mat-label>NIP</mat-label>
                                <input matInput [formControl]="email" required />
                                <mat-error *ngIf="email.invalid">{{
                                    getEmailErrorMessage()
                                    }}</mat-error>
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Password</mat-label>
                                <input matInput [type]="hidePassword ? 'password' : 'text'" [formControl]="password"
                                    (keydown.enter)="f.form.valid && onSubmit()" />
                                <button mat-icon-button matSuffix (keydown.enter)="hidePassword = true"
                                    (click)="hidePassword = !hidePassword" [attr.aria-label]="'Hide password'"
                                    [attr.aria-pressed]="hidePassword">
                                    <mat-icon>{{
                                        hidePassword ? 'visibility_off' : 'visibility'
                                        }}</mat-icon>
                                </button>
                                <mat-error *ngIf="password.invalid">{{
                                    getPasswordErrorMessage()
                                    }}</mat-error>
                            </mat-form-field>
                            <p *ngIf="isLoginFailed" style="color: red;">Periksa kembali NIP dan Password Anda</p>
                            <div>
                                <button mat-raised-button type="submit" mat-raised-button color="primary"
                                    *ngIf="!isLoading">Login</button>
                                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                            </div>
                        </form>
                        <button mat-button class="small-center-text" [routerLink]="['/resetpassword']">
                            <span>Lupa Password?</span>
                        </button>
                    </mat-card-content>
                </mat-card>
            </div>
            <div fxFlex.gt-lg="30" fxFlex.gt-md="30" fxFlex.gt-xs="100" fxFlex="100"></div>
        </div>
    </div>
</div>